import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { AgentDefinition, SDLC_GROUP_META, SdlcGroup } from '../types';
import { useAgents } from '../hooks/useAgents';
import { SDLCGroupSection } from './SDLCGroupSection';
import '../styles/ai-chatbots.css';

export const CatalogPage: React.FC = () => {
  const history = useHistory();
  const { agents, loading, usingFallback } = useAgents();

  const groupedAgents = useMemo(() => {
    const groups: Partial<Record<SdlcGroup, AgentDefinition[]>> = {};
    for (const agent of agents) {
      if (!groups[agent.sdlcGroup]) groups[agent.sdlcGroup] = [];
      groups[agent.sdlcGroup]!.push(agent);
    }
    return groups;
  }, [agents]);

  const orderedGroups = Object.keys(SDLC_GROUP_META) as SdlcGroup[];

  const handleChatClick = (agent: AgentDefinition) => {
    history.push(`/ai-chat-agents/chat?agentId=${agent.id}`);
  };

  return (
    <div className="quicklinks-page agent-catalog-page">
      <div className="page-header">
        <h1>🤖 AI Agents</h1>
        <p>Browse AI agents across the SDLC. Click a live agent to chat.</p>
      </div>

      {usingFallback ? (
        <div className="agent-catalog-empty-state">
          <div className="agent-catalog-empty-state__icon">🔌</div>
          <h3 className="agent-catalog-empty-state__title">Agents unavailable</h3>
          <p className="agent-catalog-empty-state__desc">The agent database is currently unreachable. Please try again later.</p>
        </div>
      ) : loading ? (
        <div className="agent-catalog-loading">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="agent-tile agent-tile--skeleton" aria-hidden="true" />
          ))}
        </div>
      ) : (
        orderedGroups
          .filter((group) => groupedAgents[group] && groupedAgents[group]!.length > 0)
          .map((group) => (
            <SDLCGroupSection
              key={group}
              group={group}
              agents={groupedAgents[group]!}
              onChatClick={handleChatClick}
            />
          ))
      )}
    </div>
  );
};
